import {api} from '@/libs/baseApi.client';

export const removeFavoritesOptions = async (eeId: number) => {
  const response = await api.post(`/ee/favorites/remove`, {
    eeId,
  });
  return response.data;
};
